"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SearchField_1 = tslib_1.__importDefault(require("./SearchField"));
/**
 * @deprecated use {@link WCAGOrganisationSearchField} instead
 */
class OrganisationSearchField extends SearchField_1.default {
    constructor(element) {
        super(element);
    }
    format(suggestion) {
        const orgId = this.formatOrgId(suggestion);
        if (!suggestion.OrganisationName) {
            return orgId || "ukendt navn";
        }
        const organisationId = orgId ? "(" + orgId + ")" : "";
        const duplicateString = suggestion.IsDuplicate ? "(Dublet)" : "";
        return `${suggestion.OrganisationName} ${organisationId} ${duplicateString}`;
    }
    search(query) {
        if (query.length < this.getMinQueryLength()) {
            this.populateSuggestions([], false);
        }
        else {
            this.suggestOracle.requestSuggestions(query).then((response) => {
                this.populateSuggestions(response.suggestions || [], true, response.moreSuggestions);
            });
        }
    }
    formatOrgId(value) {
        let orgId;
        let orgIdPrefix;
        if (value.OrganisationType) {
            switch (value.OrganisationType) {
                case "Doctor":
                    orgId = "" + value.DoctorOrganisationIdentifier;
                    orgIdPrefix = `${value.DoctorOrganisationSpecialityText?.toLowerCase()}, yder: `;
                    break;
                case "Hospital":
                    orgId = value.HospitalOrganisationIdentifier;
                    orgIdPrefix = "sks: ";
                    break;
                case "Municipality":
                    orgId = "" + value.MunicipalityOrganisationIdentifier;
                    orgIdPrefix = "kommune: ";
                    break;
                case "Pharmacy":
                    orgId = "" + value.PharmacyIdentifier;
                    orgIdPrefix = "apotek: ";
                    break;
                case "SOR":
                    orgId = `${value.SorId}`;
                    orgIdPrefix = `${value.SorType}, sor: `;
                    break;
            }
        }
        return orgIdPrefix + orgId;
    }
}
exports.default = OrganisationSearchField;
//# sourceMappingURL=OrganisationSearchField.js.map